import { cn } from "@ui/lib/utils";

const MAX = 80; // s
const MIN = 40; // s

interface DepthScrollerProps {
  asset: React.ReactNode;
  centralElementZIndex?: number;
  fewerOnMobile?: boolean;
  items: React.ReactNode[];
  scaleRatio?: number;
}

export default function DepthScroller({
  asset,
  items,
  scaleRatio = 0.5,
  centralElementZIndex = 0,
  fewerOnMobile = false,
}: DepthScrollerProps) {
  return (
    <div className='overflow-hidden'>
      <div className='oveflow-hidden relative pt-64 md:pt-80'>
        {items.map((item, i) => {
          return (
            <div
              className={cn("animate-ds-slide absolute top-0 z-10", fewerOnMobile && i % 2 === 1 && "hidden md:block")}
              key={`item-${i}`}
              style={
                {
                  zIndex: i % 2 ? centralElementZIndex + 1 : centralElementZIndex - 1,
                  "--ds-scale": Math.random() * (1 - scaleRatio) + scaleRatio, // scaleRatio to 1
                  "--ds-delay": `-${Math.floor(Math.random() * MAX)}s`, // 0 to MAX
                  "--ds-duration": `${Math.floor(Math.random() * MAX) + MIN}s`, // MIN to MAX
                  top: `${Math.floor(Math.random() * 60)}%`,
                } as React.CSSProperties
              }
            >
              {item}
            </div>
          );
        })}
        <div className='container flex justify-center'>
          <div className='pb-64 xl:w-8-cols xxxl:w-10-cols'>{asset}</div>
        </div>
      </div>
      {/* <span className='invisible opacity-0'>{items[0]}</span> */}
    </div>
  );
}
